// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"InfoBox_bannerWrapper__Ya3B9"};